import React from "react";
import { Button } from "antd";
import TrebbleConfigProvider from "./ConfigProvider"; // Renamed from ConfigProvider to TrebbleConfigProvider based on previous context
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

// Infer props from the Button component
interface TrebbleButtonProps extends React.ComponentProps<typeof Button> {
  useEditorTheme?: boolean;
}

const TrebbleButton = ({ useEditorTheme, ...restProps }: TrebbleButtonProps) => {
  // Pass useEditorTheme to the hook, assuming it accepts it like other wrappers
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme }); 

  return (
    // Use TrebbleConfigProvider and pass useEditorTheme
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Button {...restProps} /> 
    </TrebbleConfigProvider>
  );
};

export default TrebbleButton; 